export default class StripeConfig {

    // @ngInject
    constructor() {
        this.key = null;

        this.sdkSrc = 'https://js.stripe.com/v2/';

        this.reportNonFieldError = alert;

        this.fields = [
            'name',
            'number',
            'exp_month',
            'exp_year',
            'cvc',
            'address_line1',
            'address_line2',
            'address_zip',
            'address_city',
            'address_state',
            'address_country'
        ];

        this.supportedBrands = [
            'Visa',
            'American Express',
            'MasterCard'
        ];
    }

    $get() {
        return this;
    }
}



// WEBPACK FOOTER //
// ./stripe/config/stripe-config.js